// package
import { Fragment, useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import {
  Button,
  Card,
  Col,
  Row,
  OverlayTrigger,
  Tooltip,
  Form,
  Spinner
} from "react-bootstrap";
import AmlHashForm from "aml-hash-form";

// component
import PageBreadcrumb from "elements/System/PageBreadcrumb";
import FieldSelect from "elements/System/FieldSelect";
import AgDelete from "elements/System/AgDelete";
import AgStatus from "elements/System/AgStatus";
import { api, common } from "includes";

export default function AddUnit() {
  // const
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  let mode = searchParams.get("mode");
  let id = searchParams.get("id");

  // state
  const [process, setProcess] = useState<any>({ result: 100 });
  const [confirm, setConfirm] = useState<any>({ id: null, type: null });
  const [submit, setSubmit] = useState<any>("");
  const [resultList, setResultList] = useState<any>(null);
  const [finder, setFinder] = useState({
    locality: true,
  });
  const [effectField, setEffectField] = useState<any>([]);
  const [permission] = useState(common.getUserPermission());

  // form
  const formFields = {
    unitName: { validate: ["req#Unit Name is required"] },
    locality: {
      validate: ["objValReq#Locality is required!"],
      obj: "value",
    },
    // latitude: { validate: ["req#Latitude is required"] },
    // longitude: { validate: ["req#Longitude is required"] },
  };

  const {
    fields,
    errors,
    handleChange,
    handleSubmit,
    setValue,
    setMultiValue,
  } = AmlHashForm(formFields);

  // effect
  useEffect(() => {
    if (id) {
      getData();
    } else {
      processState("result", 200)
    }
  }, []);

  useEffect(() => {
    if (id) {
      getData();
    } else {
      processState("result", 200)
    }
  }, [mode]);

  useEffect(() => {
    if (effectField.length > 0) {
      setValue(effectField[0], effectField[1]);
      setFinder((prev) => ({ ...prev, [effectField[0]]: false }));
    }
  }, [effectField]);

  // api 
  const getData = () => {
    processState("result", 100)
    let data: any = {
      url: `admin/prefilled-locality-unit/one/${id}`,
      method: "GET",
    };
    api.call(
      data,
      (res: any) => {
        processState("result", res.status);
        if (res.status === 200) {
          let result = res.data;
          setResultList(result);
          setMultiValue({
            unitName: result.unitName || "",
            locality: result.locality?._id || "",
            // latitude: result.latitude || "",
            // longitude: result.longitude || ""
          });
        }
      }
    );
  };

  const save = () => {
    let data = common.formPayload(fields, []);
    data.locality = fields?.locality?.value;

    let param = {
      url: id ? `admin/prefilled-locality-unit/one/${id}` : `admin/prefilled-locality-unit`,
      method: id ? "PUT" : "POST",
      body: data,
    };

    api.call(
      param,
      (res: any) => {
        if (res.status === 200) {
          if (id) {
            common.notify("S", "Unit updated successfully");
            navigate(`/unit/form?id=${id}&mode=view`);
            processState("result", 100)
            getData();
          } else {
            common.notify("S", "Unit added successfully");
            navigate(`/unit/list`);
          }
        } else {
          common.notify("E", res?.data.error);
        }
        setSubmit("");
      }
    );
  };

  const deleteLocality = () => {
    let data: any = {
      url: `admin/prefilled-locality-unit/one/${confirm.id}`,
      method: "DELETE",
    };

    api.call(data, (res: any) => {
      if (res.status === 200) {
        setConfirm({ id: null, type: "" });
        common.notify("S", "Unit deleted successfully");
        navigate(`/unit/list`);
      } else {
        common.notify("E", res.error);
      }
    });
  };

  // events
  const onSubmit = (e: any) => {
    e.preventDefault();
    const isValid = handleSubmit();
    console.log("===============isValid", isValid);

    if (isValid) {
      setSubmit("submit");
      save();
    }
  };

  const deleteCallBack = (isDelete: boolean) => {
    if (isDelete) {
      deleteLocality();
    } else {
      setConfirm({ id: null, type: "" });
    }
  };

  // callback
  const onAgCallBack = (status: any) => {
    getData();
  };

  // support
  const processState = (label: any, value: any) => {
    setProcess((prev: any) => ({
      ...prev,
      [label]: value
    }));
  }

  return (
    <Fragment>
      <PageBreadcrumb
        breadCrumbItems={[
          { label: "Units", path: "/unit/list" },
          { label: "Units Form", path: "", active: true },
        ]}
        title={"Units Form"}
      />
      {process.result != 200 ? (
        <AgStatus
          process={process.result}
          message={{
            100: "Loading... Please wait!",
            404: "Something went wrong! Please Refresh Again",
          }}
          button={{ 400: "Refresh", 404: "Refresh" }}
          size="l"
          onAgCallBack={onAgCallBack}
        />
      ) : (<Fragment>
        {mode != "view" ? (
          <Fragment>
            {" "}
            <Row>
              <Col xl={12} lg={12}>
                <Card>
                  <Card.Body className="py-1 px-1 border-bottom border-light">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="float-start">
                        <OverlayTrigger
                          placement="bottom"
                          overlay={<Tooltip id="">Back</Tooltip>}
                        >
                          <Link
                            to="/unit/list"
                            className="text-reset fs-20 p-1 d-inline-block"
                          >
                            <i
                              className="ri-arrow-left-s-line pe-2"
                              data-bs-container="#tooltips-container"
                              data-bs-toggle="tooltip"
                            />
                          </Link>
                        </OverlayTrigger>
                        <label className="form-check-label fs-16">
                          {id ? "Edit" : "Add"} Unit
                        </label>
                      </div>
                      <div id="tooltips-container d-flex align-items-center">
                        <div className="d-flex flex-wrap gap-2">
                          <Button variant="secondary" onClick={() => { navigate("/unit/list") }} disabled={submit === "submit"}>
                            <i className=" ri-arrow-go-back-line me-1" />
                            Cancel
                          </Button>
                          <>{console.log("==============submit", submit)}
                          </>
                          <Button variant="primary" onClick={onSubmit} disabled={submit === "submit"}>
                            {submit === "submit" ? (
                              <>
                                <Spinner className="spinner-border-sm me-1" color="white" />
                                Processing...
                              </>
                            ) : (
                              <><i className="ri-save-line" /> Save</>
                            )}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <Card.Body>
                    <Form>
                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                              type="text"
                              name="unitName"
                              id="singleLine"
                              maxLength={100}
                              data-toggle="maxlength"
                              placeholder="Enter Unit Name"
                              value={fields.unitName}
                              onChange={handleChange}
                              isInvalid={errors.unitName ? true : false}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.unitName}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>Locality</Form.Label>
                            <FieldSelect
                              api="admin/locality"
                              query="?offset=1&limit=1000"
                              get="name"
                              set="_id"
                              value={fields?.locality}
                              placeholder="Please select the locality"
                              render={"yes"}
                              clearable={true}
                              finder={finder?.locality}
                              multi={false}
                              onSelect={(data: any) => {
                                setEffectField(["locality", data]);
                              }}
                            />
                            <p className="text-danger fs-6">{errors.locality}</p>
                          </Form.Group>
                        </Col>
                        {/* <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>Latitude</Form.Label>
                            <Form.Control
                              type="text"
                              name="latitude"
                              id="singleLine"
                              maxLength={100}
                              data-toggle="maxlength"
                              placeholder="Enter latitude"
                              value={fields.latitude}
                              onChange={handleChange}
                              isInvalid={errors.latitude ? true : false}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.latitude}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>Longitude</Form.Label>
                            <Form.Control
                              type="text"
                              name="longitude"
                              id="singleLine"
                              maxLength={100}
                              data-toggle="maxlength"
                              placeholder="Enter Longitude"
                              value={fields.longitude}
                              onChange={handleChange}
                              isInvalid={errors.longitude ? true : false}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.longitude}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col> */}
                      </Row>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Fragment>
        ) : (
          <Fragment>
            <Row>
              <Col xl={12} lg={12}>
                <Card>
                  <Card.Body className="py-1 px-1 border-bottom border-light">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="float-start">
                        <OverlayTrigger
                          placement="bottom"
                          overlay={<Tooltip id="">Back</Tooltip>}
                        >
                          <Link
                            to="/unit/list"
                            className="text-reset fs-20 p-1 d-inline-block"
                          >
                            <i
                              className="ri-arrow-left-s-line pe-2"
                              data-bs-container="#tooltips-container"
                              data-bs-toggle="tooltip"
                            />
                          </Link>
                        </OverlayTrigger>
                        <label className="form-check-label fs-16">
                          Unit Information
                        </label>
                      </div>
                      {permission.includes("ulu") && <div id="tooltips-container d-flex align-items-center">
                        <div className="d-flex flex-wrap gap-2">
                          <OverlayTrigger
                            placement="bottom"
                            overlay={<Tooltip id="">Edit</Tooltip>}
                          >
                            <Button
                              className="btn btn-light"
                              onClick={() => {
                                navigate(`/unit/form?id=${id}&mode=edit`);
                              }}
                            >
                              <i
                                className="ri-edit-2-line"
                                data-bs-container="#tooltips-container"
                                data-bs-toggle="tooltip"
                              />
                            </Button>
                          </OverlayTrigger>
                        </div>
                      </div>}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <Card.Body>
                    <Form>
                      <Row>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Unit Name</Form.Label>
                            <p className="text-muted fs-14">{resultList.unitName || "-"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Locality</Form.Label>
                            <p className="text-muted fs-14">{resultList?.locality?.name || "-"}</p>
                          </Form.Group>
                        </Col>
                        {/* <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Latitude</Form.Label>
                            <p className="text-muted fs-14">{resultList.latitude || "-"}</p>
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>Longtitude</Form.Label>
                            <p className="text-muted fs-14">{resultList.longitude || "-"}</p>
                          </Form.Group>
                        </Col> */}
                        {permission.includes("uld") && <Col md={4}>
                          <Button
                            variant="danger"
                            size="sm"
                            className="me-1 d-felx align-items-center"
                            onClick={() => setConfirm({ id: id, type: "locality" })}
                          >
                            <i className="ri-delete-bin-line fs-16" />
                            <span className="ms-1">Permanently Delete Unit</span>
                          </Button>
                        </Col>}
                      </Row>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Fragment>
        )}
      </Fragment>
      )}
      {/* Delete confirmation */}
      {confirm.id && (
        <AgDelete
          type="delete"
          onAgDeleteCallBack={deleteCallBack}
        />
      )}
    </Fragment>
  );
}